/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_chat_shortcuts_top_up_message = /** @type {(inputs: {}) => string} */ () => {
	return `Necesito recargar mi cuenta`
};

const en_chat_shortcuts_top_up_message = /** @type {(inputs: {}) => string} */ () => {
	return `I need to top-up my account`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const chat_shortcuts_top_up_message = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.chat_shortcuts_top_up_message(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("chat_shortcuts_top_up_message", locale)
	if (locale === "es") return es_chat_shortcuts_top_up_message(inputs)
	return en_chat_shortcuts_top_up_message(inputs)
};
export { chat_shortcuts_top_up_message as "chat.shortcuts.top_up_message" }